var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlSwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.5,
    height: 154.5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 154.5 154.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 99.69626,
    y1: 620.45578,
    x2: 111.04553,
    y2: 589.3418,
    gradientTransform: "translate(0 -573.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -530.58342,
    y1: 2812.69781,
    x2: -516.0481,
    y2: 2781.69418,
    gradientTransform: "translate(-474.62101 2920.3999) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 130.7796,
    y1: 2812.67021,
    x2: 145.22536,
    y2: 2781.69288,
    gradientTransform: "translate(-32.2 2920.3999) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -531.01185,
    y1: 620.31427,
    x2: -516.56609,
    y2: 589.25977,
    gradientTransform: "translate(-474.62101 -573.5) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 154.5,
    height: 154.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2",
    "data-name": "mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qlkrnwc5ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.02175,45.5775l-8.652-4.326,8.343-16.60875c1.62225-3.2445,4.944-5.33025,8.652-5.33025h16.29975v9.65625h-16.29975l-8.343,16.60875Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.398,38.625c-7.95675,0-14.523-6.489-14.523-14.523s6.489-14.44575,14.523-14.44575,14.44575,6.489,14.44575,14.44575-6.489,14.523-14.44575,14.523ZM130.398,19.3125c-2.70375,0-4.86675,2.163-4.86675,4.7895s2.163,4.86675,4.86675,4.86675,4.7895-2.163,4.7895-4.86675-2.163-4.7895-4.7895-4.7895Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47825,108.9225l8.652,4.326-8.343,16.60875c-1.62225,3.2445-4.944,5.33025-8.652,5.33025h-16.29975v-9.65625h16.29975l8.343-16.60875Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.17925,115.875c7.95675,0,14.523,6.489,14.523,14.523s-6.489,14.44575-14.523,14.44575-14.44575-6.489-14.44575-14.44575,6.489-14.523,14.44575-14.523ZM24.17925,135.1875c2.70375,0,4.86675-2.163,4.86675-4.7895s-2.163-4.86675-4.86675-4.86675-4.86675,2.163-4.86675,4.86675,2.163,4.7895,4.86675,4.7895Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.02175,108.9225l-8.652,4.326,8.343,16.60875c1.62225,3.2445,4.944,5.33025,8.652,5.33025h16.29975v-9.65625h-16.29975l-8.343-16.60875Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.84375,130.398c0,7.95675-6.489,14.44575-14.44575,14.44575s-14.523-6.489-14.523-14.44575,6.489-14.523,14.523-14.523,14.44575,6.489,14.44575,14.523ZM135.1875,130.398c0-2.70375-2.163-4.86675-4.7895-4.86675s-4.86675,2.163-4.86675,4.86675,2.163,4.7895,4.86675,4.7895,4.7895-2.163,4.7895-4.7895Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.94175,45.5775l8.652-4.326-8.343-16.60875c-1.62225-3.2445-4.944-5.33025-8.652-5.33025h-16.29975v9.65625h16.29975l8.343,16.60875Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625,24.17925c0-7.95675,6.489-14.44575,14.44575-14.44575s14.523,6.489,14.523,14.44575-6.489,14.523-14.523,14.523-14.44575-6.489-14.44575-14.523ZM19.3125,24.17925c0,2.70375,2.163,4.86675,4.86675,4.86675s4.86675-2.163,4.86675-4.86675-2.163-4.7895-4.86675-4.7895-4.86675,2.163-4.86675,4.7895Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 77.25,
    x2: 154.5,
    y2: 77.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8100e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09285,
    stopColor: "#6b12e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26122,
    stopColor: "#4a2fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43437,
    stopColor: "#3045f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61198,
    stopColor: "#1d55fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79671,
    stopColor: "#125efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 38.625,
    x2: 115.875,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 57.9375,
    y1: 76.20713,
    x2: 96.48525,
    y2: 76.20713,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h154.5v154.5H0V0Z",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.25,48.28125c15.99075,0,28.96875,12.978,28.96875,28.96875s-12.978,28.96875-28.96875,28.96875-28.96875-12.978-28.96875-28.96875,12.978-28.96875,28.96875-28.96875M77.25,38.625c-21.321,0-38.625,17.304-38.625,38.625s17.304,38.625,38.625,38.625,38.625-17.304,38.625-38.625-17.304-38.625-38.625-38.625Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4605,78.09975l-7.5705-7.80225-6.9525,6.9525,14.44575,14.523,24.102-24.17925-6.798-6.9525-17.304,17.4585h.07726Z",
    fill: "url(#linear-gradient-7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlSwitcher);
export default __webpack_public_path__ + "static/media/control_switcher.5db233108c416b328f41f2eb63f5f6e1.svg";
export { ForwardRef as ReactComponent };